/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.SubscriptionStatus_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.SubscriptionStatus domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum SubscriptionStatus_ {
   /// <summary>
   ///   New (pending registration) (New)
   /// </summary>
   New = 0,
   /// <summary>
   ///   Active (act)
   /// </summary>
   Active = 1,
   /// <summary>
   ///   On-Hold (hold)
   /// </summary>
   OnHold = 2,
   /// <summary>
   ///   Cancelled (canc)
   /// </summary>
   Cancelled = 3,
   /// <summary>
   ///   Renewal (future) (renew)
   /// </summary>
   Renewal = 4,
   /// <summary>
   ///   Ended (e.g. plan change) (end)
   /// </summary>
   Ended = 5,
   /// <summary>
   ///   Paused (paused)
   /// </summary>
   Paused = 6
}

export const SubscriptionStatuses: SubscriptionStatus[] = [
   {
      code: SubscriptionStatus_.New,
      literal: 'New',
      description: 'New (pending registration)',
      shortDescription: 'New',
      listPriority: 0,

      typeName: "SubscriptionStatus"
   },
   {
      code: SubscriptionStatus_.Active,
      literal: 'Active',
      description: 'Active',
      shortDescription: 'act',
      listPriority: 0,

      typeName: "SubscriptionStatus"
   },
   {
      code: SubscriptionStatus_.OnHold,
      literal: 'OnHold',
      description: 'On-Hold',
      shortDescription: 'hold',
      listPriority: 0,

      typeName: "SubscriptionStatus"
   },
   {
      code: SubscriptionStatus_.Cancelled,
      literal: 'Cancelled',
      description: 'Cancelled',
      shortDescription: 'canc',
      listPriority: 0,

      typeName: "SubscriptionStatus"
   },
   {
      code: SubscriptionStatus_.Renewal,
      literal: 'Renewal',
      description: 'Renewal (future)',
      shortDescription: 'renew',
      listPriority: 0,

      typeName: "SubscriptionStatus"
   },
   {
      code: SubscriptionStatus_.Ended,
      literal: 'Ended',
      description: 'Ended (e.g. plan change)',
      shortDescription: 'end',
      listPriority: 0,

      typeName: "SubscriptionStatus"
   },
   {
      code: SubscriptionStatus_.Paused,
      literal: 'Paused',
      description: 'Paused',
      shortDescription: 'paused',
      listPriority: 0,

      typeName: "SubscriptionStatus"
   }
]

export class SubscriptionStatus implements IDomainModel {
   code: SubscriptionStatus_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: SubscriptionStatus_): SubscriptionStatus {
      return SubscriptionStatuses.find(d => d.code === code)
   }
}
